var exports = {
  "xE": "x52a3aa3b--833372--alert",
  "VN": "x52a3aa3b--833372--close",
  "Lj": "x52a3aa3b--833372--alert-padding",
};

module.exports = exports;
